import { createFileRoute } from '@tanstack/react-router';
import CreateEvent from '~/containers/Experiences/CreateEvent';

export const Route = createFileRoute('/experiences/$experienceId/add-event')({
  component: CreateEvent,
});
